export default {
  organizational_structures: [],
  structure_item: null,
  tree_structure: [],
  pagination: {}
}
